// extracted by mini-css-extract-plugin
module.exports = {"Icon":"UserManagement_Icon__BVMjF"};